import Box from '@mui/material/Box';
import type { CustomVariablesFormState } from '@openx/types/targeting/advancedTargeting.ts';
import { Criteria } from '@openx/types/targeting/targetingValuesTypes.ts';
import type { Dispatch, JSX, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { Switch } from '../../shared/Switch/Switch.tsx';
import { CustomVariablesItems } from './CustomVariablesItems.tsx';

type CustomVariablesDrawerItemsProps = {
  params: CustomVariablesFormState;
  updateParams: Dispatch<SetStateAction<CustomVariablesFormState>>;
  showEmptyMessage?: boolean;
};

/** Custom variables selected in the drawer, with the ALL/ANY switch that applies to them. */
export const CustomVariablesDrawerItems = ({
  params,
  updateParams,
  showEmptyMessage = true,
}: CustomVariablesDrawerItemsProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      {params.custom.length > 0 && (
        <Box sx={{ marginTop: 2 }}>
          <Switch
            switchState={params.op === Criteria.ANY}
            onSwitchChange={() =>
              updateParams(prevParams => ({
                ...prevParams,
                op: prevParams.op === Criteria.ALL ? Criteria.ANY : Criteria.ALL,
              }))
            }
            switchOffLabel={t('all')}
            switchOnLabel={t('any')}
            groupTitle={t('of the following:')}
          />
        </Box>
      )}

      <CustomVariablesItems
        targetingParams={params}
        readonly={false}
        onChange={updateParams}
        showEmptyMessage={showEmptyMessage}
      />
    </>
  );
};
